angular.module("LeasePilot").factory("PartnersService", [
  "$http",
  function($http) {
    return {
      assignBuildings: function(partnerId, buildingIds) {
        return $http.post(`/api/partners/${partnerId}/assign_buildings`, { building_ids: buildingIds });
      }
    };
  }
]); 